module.exports = __webpack_public_path__ + "static/media/Group 6991.6fc383c0.png";